<template>
  <q-card
    :class="[
      'meta col-12 row cursor-pointer shadow-1',
      isSelected ? 'unfocus' : '',
    ]"
    :style="metaBackground"
    @mouseover="metaOver()"
    @mouseleave="metaLeave()"
    @click="openURL()"
    bg-primary
  >
    <div class="row col-12">
      <div
        :class="['title-container']"
      >
      <div>{{ metaName }}</div>
      </div>
    </div>
  </q-card>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';

export default {
  mixins: [Message],
  props: {
    meta: Object,
    metaPositionArray: Number,
    color: String,
    colorhover: String,
    idObjetivo: String,
    isSelected: Boolean
  },
  data () {
    return {
      metaBackground: {
        backgroundColor: `${this.color}`
      },
      metaName: this.meta.name
    };
  },
  methods: {
    async openURL () {
      var param = {
        objetivo: this.idObjetivo,
        meta: this.meta.name,
        metaPosition: this.metaPositionArray,
        metaId: this.meta.id
      };

      var paramMeta = this.meta.id;

      this.$eventHub.$emit('open_indicadores', {
        param,
        done: () => {
          this.$emit('showActions', {
            paramMeta,
            done: () => {
            }
          });
        }
      });

      this.$emit('openIndicadores', {
        param,
        done: () => {
          this.$emit('showActions', {
            paramMeta,
            done: () => {
              this.savePositionContainer(this);
            }
          });
        }
      });
    },
    savePositionContainer (item) {
      window.scrollTo({ top: item.$el.offsetTop, behavior: 'smooth' });
    },
    metaOver () {
      this.metaBackground.backgroundColor = this.colorhover;
    },
    metaLeave () {
      this.metaBackground.backgroundColor = this.color;
    }
  },
  watch: {
    color: {
      handler: function () {
        this.metaBackground.backgroundColor = this.color;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.unfocus {
  opacity: 0.57;
}
.meta {
  transition: box-shadow 0.3s;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12),
    0 1px 1px 0 rgba(0, 0, 0, 0.14);
  align-items: center;
  display: flex;
  font-weight: bold;
  margin-bottom: 10px;
  min-height: 62px;
  margin: 10px 20px;
  &:hover {
    box-shadow: $shadow-4;
  }
  padding: 0px 0px 0px 0px !important;
}
.title-container{
  min-height: 62px;
  div{
    padding: 20px 20px;
  }
}

@media (max-width: 640px) {
  .title-container{
    div{
      padding: 14px;
    }
  }
  .meta{
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
